import { Paper, Typography, TableContainer, TableHead, TableRow, TableCell, TableBody, Checkbox } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useContext, useMemo } from "react";
import { SessionContext } from "../../../Contexts/SessionContext";
import { getFilteredSurveys } from "../../../TripRateNew/TriprateFilters";
import DropDownViewModel from "../../../Utilities/ViewModels/DropDownViewModel";
import { useTripRateContext } from "../../TripRateContext";
import Line from '../../../Utilities/Line';
import CompactTable from "../../../Utilities/CompactTable";
import { CounterBadge } from '../../../Utilities/CounterBadge';
import useData from "../../../Utilities/Hooks/UseData";
import { getValueAtPath } from "./SecondaryFilterTickbox";
import { DotNestedKeys } from "../../../Utilities/Types/SessionType";
import { SurveyFullViewModel } from "../../../TripRateNew/ViewModels/SurveyFullViewModel";
import { SessionState } from "../../../Contexts/SessionState";

interface IProps {
    heading: string;
    path: DotNestedKeys<SessionState>;
    id: keyof SurveyFullViewModel;
    alertCondition?: (items: DropDownViewModel[], selected: any[]) => boolean;
    canCollapseZeroCounts?: boolean;
    badgeNumber?: string;
    isCompressedSummary?: boolean;
}

export default function PTALFilter(props: IProps) {
    const { surveys } = useTripRateContext();
    const { sessionState, setSessionField } = useContext(SessionContext);
    const selected = getValueAtPath<any[]>(sessionState, props.path) ?? [];

    const filteredSurveys = useMemo(() => {
        return getFilteredSurveys(
            surveys,
            { fetchAction: 'GetPtalRating' }
        );
    }, [surveys, sessionState]);

    const { data: baseDropdown } = useData<DropDownViewModel[]>(
        'TripRateFilterNew',
        'GetPtalRating'
    );

    const dropdown = useMemo(() => {
        if (!baseDropdown?.length)
            return baseDropdown ?? [];

        return baseDropdown.map((x) => {
            const count = filteredSurveys?.filter((s) => s.ptal?.toLowerCase() === x.id.toLowerCase()).length ?? 0; // CASE CHECK HERE NEEDED IN MARCH 2026
            return { ...x, data: count };
        });
    }, [filteredSurveys, baseDropdown]);

    const handleChange = (index: number) => (e: React.ChangeEvent<HTMLInputElement>) => {
        const id = dropdown[index].id;
        const selectedIds = selected.filter((x) => x != null);
        const updated = e.target.checked
            ? [...selectedIds, id]
            : selectedIds.filter((x) => x !== id);

        setSessionField(props.path, updated);
    };

    const isSelected = (id: number) => selected.includes(id);

    return (
        <Grid container size={12} component={Paper}
            sx={{ position: 'relative' }}>
            <CounterBadge value={props.badgeNumber ?? ""} />
            <Grid
                container
                size={12}
                alignItems="center"
            >
                <Typography
                    textAlign="center"
                    sx={{ width: '100%', fontWeight: 500 }}
                >
                    PTAL Rating
                </Typography>
            </Grid>


            <Line />
            <Grid size={12}>
                <TableContainer>
                    <CompactTable>
                        <TableHead>
                            <TableRow>
                                <TableCell>Day</TableCell>
                                <TableCell>Count</TableCell>
                                <TableCell>
                                    Include{' '}
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {dropdown?.map((x, index) => {
                                return (
                                    <TableRow key={x.id}>
                                        <TableCell>{x.label}</TableCell>
                                        <TableCell>{x.data}</TableCell>
                                        <TableCell>
                                            <Checkbox
                                                checked={isSelected(x.id)}
                                                onChange={handleChange(index)}
                                            />
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </CompactTable>
                </TableContainer>
            </Grid>
        </Grid>
    );
}
